import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Input, Form, Select } from 'antd';

//Redux imports
import { connect } from 'react-redux';
import { handleChange, handleMultipleChange } from '../../../actions/PickupActions';

//constants
import Helper from '../../../common/consts/Helper';
import moment from 'moment';

import { Modal } from 'react-responsive-modal';

//cards
import CardImage from '../../../assets/cards.png';

import {
    CardElement,
    useStripe,
    useElements,
    PaymentRequestButtonElement
} from '@stripe/react-stripe-js';
import { countries } from '../../../common/consts/ProtaxHelpers';
import { toast } from 'react-toastify';

const { Option } = Select;

const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const CARD_OPTIONS = {
    iconStyle: 'solid',
    style: {
        base: {
            fontWeight: 500,
            fontSize: '16px',
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSmoothing: 'antialiased',
            border: '1px solid #a0a'
        },
        invalid: {
            // iconColor: '#ffc7ee',
        },
    },
};

function PaymentFinal(props) {


    const { PickupParams, amountToTransact, getAmountToTransact, payment,
        totalAmount,
        orderId, isReauthorized } = props;


    const [isLoading, setIsLoading] = useState(false);
    const [paymentRequest, setPaymentRequest] = useState(null);

    const stripe = useStripe();
    const elements = useElements();



    const handlePayment = async (values) => {
        const card = elements.getElement(CardElement);
        var paymentRequest = await stripe.createToken(card);
        if (paymentRequest && paymentRequest?.token?.id) {
            if(isReauthorized){
                makePayment(orderId, paymentRequest?.token?.id, true, isReauthorized);
            }
            else{
                makePayment(orderId, paymentRequest?.token?.id, false);
            }
        }
    };

    function makePayment(id, token, isReauthorize, amount) {
        setIsLoading(true);
        let res = Helper('add_payment', 'POST', {
            source: token,
            orderId: id,
            amount: isReauthorize ? (amount) : (Math.ceil(+getAmountToTransact() * 100))
        });
        res.then((response) => {
            setIsLoading(false)
            if (response.error) {
                toast.error(response?.error?.toString());
            }
            else {
                toast.success(response?.message);
                props.history.push('/orders');
            }
        })
            .catch((error) => {
                setIsLoading(false);
            })
            .finally(() => { setIsLoading(false) })
    }


    return (
        <Modal open={props.modalVisible} onClose={() => { props.setModalVisible(false) }} center>
            <Row style={{ marginTop: "50px", marginBottom: "50px", display: "flex", justifyContent: "center" }}>
                <Col md={{ span: 22 }}>
                    <Card
                        title="Fill your card details and Pay!"
                        headStyle={{ background: "#b0000b", color: "#fff", borderRadius: "12px 12px 0px 0px", fontSize: '22px' }} style={{ borderRadius: "12px" }}
                    >
                        <Form
                            {...layout}
                            onFinish={(values) => {
                                handlePayment(values)
                            }}
                        >
                            <Row gutter={24}>
                                <Col xs={{ span: 24 }} className="mb-2">
                                    <CardElement
                                        options={CARD_OPTIONS}
                                    />
                                </Col>
                                {/* <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Name"
                                        name="name"
                                        rules={[{ required: true, message: 'Please input your Name!' }]}
                                    >
                                        <Input
                                            placeholder="Full Name"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[
                                            { required: true, message: 'Please input your Email!' },
                                            { type: 'email', message: 'Please input a valid Email!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Email"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Phone"
                                        name="phone"
                                        rules={[
                                            { required: true, message: 'Please input your Phone!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Phone"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Address line 1"
                                        name="line1"
                                        rules={[
                                            { required: true, message: 'Please input Address line 1!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Address line 1"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Address line 2"
                                        name="line2"
                                        rules={[
                                            { required: true, message: 'Please input Address line 2!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Address line 2"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="City"
                                        name="city"
                                        rules={[
                                            { required: true, message: 'Please input City!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="City"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} >
                                    <Form.Item
                                        label="Postal Code"
                                        name="postal_code"
                                        rules={[
                                            { required: true, message: 'Please input Postal Code!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Postal Code"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} >
                                    <Form.Item
                                        label="State"
                                        name="state"
                                        rules={[
                                            { required: true, message: 'Please input State!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="State"
                                            style={{ height: "2.2rem" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item
                                        label="Country"
                                        name="country"
                                        rules={[
                                            { required: true, message: 'Please select a Country!' },
                                        ]}
                                        initialValue="CA"
                                    >
                                        <Select
                                            defaultValue="CA"
                                            style={{ width: '100%', height: '2.2rem' }}

                                        >
                                            {
                                                countries.map((country, index) => {
                                                    return (
                                                        <Option
                                                            key={index}
                                                            value={country.code}
                                                        >{country.name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col> */}
                                <Col xs={{ span: 24 }} className="mb-2 d-flex">
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        className="protax-btn mx-auto text-bold"
                                        loading={isLoading}
                                    >
                                        PAY ${amountToTransact}
                                    </Button>
                                </Col>
                                <Col xs={{ span: 24 }} className="d-flex">
                                    <img
                                        src={CardImage}
                                        className="mx-auto"
                                        height="40"
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col >
            </Row >
        </Modal>
    );
}



const mapStateToProps = () => state => ({
    PickupParams: state.Pickup,
});

const mapDispatchToProps = () => dispatch => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(PaymentFinal);
